import {Dimensions, StyleSheet} from 'react-native';
import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import {CustomText} from '@buncha/components/core/text';
import ExpandView from '@buncha/components/core/view/ExpandView';
import If from '@buncha/components/conditional/If';
import {ItemDetailedDescription} from '@buncha/itemDetails/types/ReplacementItemDetails';

const ItemDetails = (props: {item: ItemDetailedDescription}) => {
  const fontTheme = useFontTheme();
  const theme = useColorThemeType();
  const {item} = props;
  const {width: SCREEN_WIDTH} = Dimensions.get('window');

  const generateHtml = useCallback(
    (content: string) => {
      return `
    <!DOCTYPE html>\n
    <html>
      <head>
        <title>Web View</title>
        <meta http-equiv="content-type" content="text/html; charset=utf-8">
        <meta name="viewport" content="width=${SCREEN_WIDTH}, user-scalable=no">
        <style type="text/css">
          body {
            margin: 0;
            padding: 0;
          }
        </style>
      </head>
      <body>
      ${content}
      </body>
    </html>
    `;
    },
    [SCREEN_WIDTH],
  );

  return (
    <Box style={styles.container}>
      <ExpandView key={item.key}>
        <If condition={item.key === 'nutritionDetails'}>
          <Box style={[styles.webviewContainer]}>
            <div
              dangerouslySetInnerHTML={{__html: generateHtml(item.data) ?? ''}}
              style={styles.htmlMainContainer}
            />
          </Box>
        </If>
        <If condition={item.key !== 'nutritionDetails'}>
          <Box style={[styles.textContainer]}>
            <CustomText
              style={[
                styles.details,
                {
                  fontFamily: fontTheme?.[600]?.normal,
                  color: theme?.text?.gray[100],
                },
              ]}>
              {item.data}
            </CustomText>
          </Box>
        </If>
      </ExpandView>
    </Box>
  );
};

export default React.memo(ItemDetails);

const styles = StyleSheet.create({
  container: {marginTop: -1, marginBottom: 10},
  webviewContainer: {alignItems: 'center'},
  expand: {
    height: 30,
    width: 30,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  details: {
    textAlign: 'left',
    marginLeft: 3,
  },
  textContainer: {
    paddingTop: 10,
    justifyContent: 'flex-start',
  },
  htmlMainContainer: {
    display: 'flex',
    margin: 20,
  },
});
